// extracted by mini-css-extract-plugin
export var aboveInput = "_nk-0";
export var actionButton = "_nk-5";
export var actionButtonContainer = "_nk-1";
export var actionIcon = "_nk-6";
export var aiInfoContainer = "_nk-2";
export var attachmentWrapper = "_nk-7";
export var bold = "_nk-3";
export var checkIcon = "_nk-8";
export var clickingRecipientBar = "_nk-11";
export var commentThreadSwitch = "_nk-a";
export var draftImage = "_nk-b";
export var draftImageContainer = "_nk-c";
export var draftImages = "_nk-e";
export var editButton = "_nk-g";
export var editor = "_nk-f";
export var editorContainer = "_nk-y";
export var editorErrorTooltipWrapper = "_nk-9";
export var headerDivider = "_nk-h";
export var icon = "_nk-i";
export var info = "_nk-j";
export var internal = "_nk-n";
export var internalDivider = "_nk-k";
export var internalMessage = "_nk-l";
export var messageInputCard = "_nk-m";
export var messageInputForm = "_nk-o";
export var messageInputFormInternal = "_nk-p";
export var options = "_nk-q";
export var publicMessageCustomer = "_nk-s";
export var publicMessageMerchant = "_nk-r";
export var removeImageButton = "_nk-d";
export var replyButtons = "_nk-t";
export var showSignatureButton = "_nk-u";
export var spinner = "_nk-v";
export var verticalButtonDivider = "_nk-4";
export var visibilitySelector = "_nk-w";
export var warning = "_nk-x";
export var wrappingText = "_nk-z";
export var writingInternalNoteTopBorder = "_nk-10";